import { useFormikContext } from "formik"
import { useDEFormContext } from "../context/DEFormContext"


const StatusSection = () => {
    const formik = useFormikContext()


    return (
        <>
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                    Remarks
                </label>
                <div className="col-sm-8">
                    <textarea
                        className="form-control"
                        name="deRemark"
                        value={formik.values.deRemark}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.deRemark && formik.errors.deRemark && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.deRemark}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default StatusSection